var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaret(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4169 15.7071C12.8074 16.0976 13.4406 16.0976 13.8311 15.7071C14.2217 15.3166 14.2217 14.6834 13.8311 14.2929L12.4169 15.7071ZM13.8311 5.70711C14.2217 5.31658 14.2217 4.68342 13.8311 4.29289C13.4406 3.90237 12.8074 3.90237 12.4169 4.29289L13.8311 5.70711ZM13.8311 14.2929L9.18468 9.64645L7.77047 11.0607L12.4169 15.7071L13.8311 14.2929ZM9.18468 10.3536L13.8311 5.70711L12.4169 4.29289L7.77047 8.93934L9.18468 10.3536ZM9.18468 9.64645C9.37995 9.84171 9.37994 10.1583 9.18468 10.3536L7.77047 8.93934C7.18468 9.52512 7.18468 10.4749 7.77047 11.0607L9.18468 9.64645Z",
    fill: "#767B87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaret);
export default __webpack_public_path__ + "static/media/caret.d30f49b7e69d79f5ca223f1f39ec500e.svg";
export { ForwardRef as ReactComponent };